import { render, staticRenderFns } from "./ayuda-form.vue?vue&type=template&id=354e2512&scoped=true"
import script from "./ayuda-form.vue?vue&type=script&lang=js"
export * from "./ayuda-form.vue?vue&type=script&lang=js"
import style0 from "./ayuda-form.vue?vue&type=style&index=0&id=354e2512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354e2512",
  null
  
)

export default component.exports